// Link de acesso direto nos e-mails do paciente (?k=, 24/10/2026). Os e-mails automáticos de pagamento, avaliação e
// renovação levam o paciente já logado para o lugar certo (/paciente, /paciente/historico?avaliar=…), com o mesmo
// link mágico do aviso de chat (services/magicLink.js, vale 72 h). Precisa rodar ANTES do PatientSessionProvider, que
// restaura a sessão uma vez só: troca o código pela sessão, tira o ?k= do endereço e recarrega.
// O /chat tem o próprio tratamento (pages/chat/page.tsx). Quem já está logado como médico/admin não troca de conta.
import { useEffect, useState, type ReactNode } from "react";
import { authAPI, getToken, getUser, persistPatientSession } from "@/lib/api";
import { capturePendingCouponFromUrl } from "@/lib/pendingCoupon";

const PATHS = /^\/paciente(\/|$)/;

export default function MagicLinkGate({ children }: { children: ReactNode }) {
  const [busy, setBusy] = useState(() => {
    try {
      const u = new URL(window.location.href);
      return !!u.searchParams.get("k") && PATHS.test(u.pathname);
    } catch { return false; }
  });

  // Cupom no link (?cupom=VOLTA10, 01/11/2026): guarda para o pagamento aplicar sozinho. Depois do login pelo link
  // (que recarrega a página com o mesmo endereço) cai aqui de novo e guarda.
  useEffect(() => {
    if (!busy) capturePendingCouponFromUrl();
  }, [busy]);

  useEffect(() => {
    if (!busy) return;
    const url = new URL(window.location.href);
    const code = url.searchParams.get("k") || "";
    url.searchParams.delete("k");
    const clean = url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : "") + url.hash;
    const role = getUser<{ role?: string }>()?.role;
    if (getToken() && role && role !== "patient") { window.history.replaceState(null, "", clean); setBusy(false); return; }
    (async () => {
      try {
        const r = await authAPI.magicLogin(code);
        const d = (r.data?.data ?? r.data) as { token?: string; patient_case_id?: number };
        if (d?.token && d.patient_case_id) {
          persistPatientSession(d.token, d.patient_case_id);
          window.location.replace(clean);
          return;
        }
      } catch { /* link vencido: segue para a tela normal (login) */ }
      window.history.replaceState(null, "", clean);
      setBusy(false);
    })();
  }, [busy]);

  if (busy) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3 text-slate-500 text-sm">
          <div className="w-8 h-8 border-2 border-slate-200 border-t-emerald-600 rounded-full animate-spin" />
          Entrando na sua conta…
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
